import { createStore, combineReducers, applyMiddleware } from "redux";
import logger from "redux-logger";
import ReduxThunk from "redux-thunk";
import promise from "redux-promise-middleware";
import carsReducer from "./reducers/carsReducer";

export default createStore(
  combineReducers({
    carsReducer
  }),
  {},
  applyMiddleware(logger, ReduxThunk)
);
